module.exports = __webpack_public_path__ + "img/circle_close.4b52dc1c.svg";